import { localIsoDate } from './date-utils';

export type MahnKanal = 'email' | 'brief' | 'telefon';

export interface MahnEventPayload {
  forderungsakte_id: string;
  stage: number;
  kanal: MahnKanal;
  email_draft_id?: string;
  dokument_id?: string;
  frist_bis?: string;
  bemerkung?: string;
}

/** Stage 0–8 advances to stage+1; stage 9 (Bezahlt, terminal) stays. */
export function nextStage(stage: number): number {
  if (stage >= 9) return 9;
  return stage + 1;
}

/**
 * Stages 1–5 trigger automatic email draft creation.
 * Stages 6–8 (Anwalt/Klage/Vollstreckung) are legal escalation stages
 * where only a template preview is shown — no email is sent automatically.
 */
export function shouldAutoSend(stage: number): boolean {
  return stage >= 1 && stage <= 5;
}

/**
 * Computes the deadline date (YYYY-MM-DD) by adding fristTage to today.
 * Returns undefined when fristTage is null/0 (no deadline for this template).
 */
export function computeFristBis(fristTage: number | null): string | undefined {
  if (!fristTage || fristTage <= 0) return undefined;
  const d = new Date();
  d.setDate(d.getDate() + fristTage);
  return localIsoDate(d);
}

export function buildMahnEventPayload({
  forderungsakte_id,
  stage,
  kanal,
  fristTage,
  email_draft_id,
  dokument_id,
  bemerkung,
}: {
  forderungsakte_id: string;
  stage: number;
  kanal: MahnKanal;
  fristTage?: number | null;
  email_draft_id?: string;
  dokument_id?: string;
  bemerkung?: string;
}): MahnEventPayload {
  const payload: MahnEventPayload = { forderungsakte_id, stage, kanal };
  if (email_draft_id) payload.email_draft_id = email_draft_id;
  if (dokument_id) payload.dokument_id = dokument_id;
  const fristBis = computeFristBis(fristTage ?? null);
  if (fristBis) payload.frist_bis = fristBis;
  if (bemerkung) payload.bemerkung = bemerkung;
  return payload;
}
